import { ApiService } from 'hay-core-react';

class PublicacaoLogModel {
    nome = 'publicacaolog';

    async list(filtros, sort, page) {
        const publicacao = filtros?.publicacao?.constraints?.[0]?.value;
        const resultado = await ApiService.post('publicacaolog/find', {
            publicacao,
            skip:  page?.first || 0,
            limit: page?.rows || 10,
            sort,
        });
        return resultado;
    }

    async get(registro) {
        return ApiService.post('publicacaolog/findOne', {
            publicacao: registro.publicacao,
            id: registro.id,
        });
    }

    async limpar(publicacao) {
        return ApiService.post('publicacaolog/limpar', { publicacao });
    }

    async catalogoCampos() {
        return ApiService.post('publicacaolog/catalogocampos', {});
    }
}

export default new PublicacaoLogModel();
